import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4;
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import css from './style.pcss';
import IconLogout from './images/ic_logout.svg';
var NMLogin = /*#__PURE__*/function (_LitElement) {
  _inherits(NMLogin, _LitElement);
  function NMLogin() {
    var _this;
    _classCallCheck(this, NMLogin);
    _this = _callSuper(this, NMLogin);
    _this.loggedIn = false;
    _this.loaded = false;
    _this.gigya = window.gigya;
    _this.user = {};
    _this.checkUserLoggedIn();
    _this.loginUrl = '//login.rtl.lu';
    _this.currentUrl = window.location.href;
    _this.translations = {
      lu: {
        login: 'Aloggen',
        settings: 'Account',
        welcome: 'Ageloggt als',
        logout: 'Logout',
        myaccount: 'Mäin Account'
      },
      fr: {
        login: 'Login',
        settings: 'Compte',
        welcome: 'Bonjour',
        logout: 'Logout',
        myaccount: 'Mon compte'
      },
      en: {
        login: 'Login',
        settings: 'Account',
        welcome: 'Welcome',
        logout: 'Logout',
        myaccount: 'My account'
      }
    };
    _this.addGigyaEventHandler();
    return _this;
  }
  _createClass(NMLogin, [{
    key: "addGigyaEventHandler",
    value: function addGigyaEventHandler() {
      var _this2 = this;
      if (!window.gigya) {
        setTimeout(function () {
          return _this2.addGigyaEventHandler();
        }, 200);
      } else {
        this.gigya = window.gigya;
        this.gigya.socialize.addEventHandlers({
          onLogin: function onLogin() {
            _this2.gigya.accounts.setSSOToken();
          }
        });
      }
    }
  }, {
    key: "getAccountInfoResponse",
    value: function getAccountInfoResponse(response) {
      this.loaded = true;
      if (parseInt(response.errorCode) === 0 && response.user.UID) {
        window.rtlsites.config.uid = response.user.UID;
        this.user = response.user;
        this.loggedIn = true;
      } else {
        this.loggedIn = false;
      }
    }
  }, {
    key: "checkUserLoggedIn",
    value: function checkUserLoggedIn() {
      var _this3 = this;
      if (!window.gigya) {
        setTimeout(function () {
          return _this3.checkUserLoggedIn();
        }, 200);
      } else {
        this.gigya = window.gigya;
        this.gigya.socialize.getUserInfo({
          callback: function callback(r) {
            return _this3.getAccountInfoResponse(r);
          }
        });
      }
    }
  }, {
    key: "logout",
    value: function logout() {
      var _this4 = this;
      this.loggedIn = false; // Hieren callback brauch emmer seu OP MANST 5 Sekonnen.
      // Vuque dass daat awer scheiss ass wann een seulaang keen feedback kritt,
      // setzten ech d'var direkt schon op false dass et seu ausgeseit wei wann een ausgeloggt wier,
      // obwuel een et dei eischt sekonnen nach net wierklech ass

      this.gigya.accounts.logout({
        callback: function callback(r) {
          return _this4.onLogout(r);
        }
      });
    }
  }, {
    key: "onLogout",
    value: function onLogout(response) {
      this.loggedIn = false;
      if (response.errorCode != 0) {
        console.log('Error :' + response.errorMessage);
      } else {
        this.loggedIn = false;
        location.reload();
      }
    }
  }, {
    key: "showLoginModal",
    value: function showLoginModal() {
      var lang = this.language;
      // if (lang === "lu") {
      //     lang = "fr-inf";
      // }
      this.gigya.accounts.showScreenSet({
        screenSet: 'Default-RegistrationLogin',
        lang: lang,
        startScreen: 'gigya-login-screen',
        enabledProviders: 'facebook,googleplus',
        onAfterSubmit: function onAfterSubmit(resp) {
          if (resp.response.errorCode == 0) {
            location.reload();
          }
        }
      });
    }
  }, {
    key: "hideLoginDropdown",
    value: function hideLoginDropdown(e) {
      e.stopPropagation();
      var smenu = this.shadowRoot.querySelector('.rtl-login__submenu');
      if (smenu) smenu.classList.remove('rtl-login__submenu--active');
    }
  }, {
    key: "toggleLoginDropdown",
    value: function toggleLoginDropdown(e) {
      e.stopPropagation();
      var smenu = this.shadowRoot.querySelector('.rtl-login__submenu');
      if (smenu) smenu.classList.toggle('rtl-login__submenu--active');
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      document.addEventListener('click', function (e) {
        this.hideLoginDropdown(e, false);
      }.bind(this));
      var language = this.language ? this.language : 'lu';
      var translations = this.translations[language];
      var content = null;

      // console.log("loadi", this.loaded, this.loggedIn)

      if (!this.loggedIn) {
        content = html(_t || (_t = _`
                <div class="rtl-login" @click=${0}>
                    <a href="#" class="rtl-login__action">
                        <span class="nav-cat__icon">
                            <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.1236 8.54449H2.8736C2.14425 8.54449 1.44478 8.83423 0.929052 9.34995C0.413327 9.86568 0.123596 10.5651 0.123596 11.2945V15.4195H1.4986V11.2945C1.4986 10.5382 2.1146 9.91949 2.8736 9.91949H11.1236C11.8812 9.91949 12.4986 10.5382 12.4986 11.2945V15.4195H13.8736V11.2945C13.8736 10.5651 13.5839 9.86568 13.0681 9.34995C12.5524 8.83423 11.8529 8.54449 11.1236 8.54449ZM6.9986 1.53199C7.83185 1.53199 8.5111 2.21124 8.5111 3.04449V4.41949C8.49446 4.80948 8.32784 5.17796 8.04601 5.44803C7.76418 5.71809 7.38893 5.86886 6.9986 5.86886C6.60826 5.86886 6.23301 5.71809 5.95118 5.44803C5.66935 5.17796 5.50273 4.80948 5.4861 4.41949V3.04449C5.4861 2.21124 6.16397 1.53199 6.9986 1.53199ZM6.9986 0.294495C6.26925 0.294495 5.56978 0.584226 5.05405 1.09995C4.53833 1.61568 4.2486 2.31515 4.2486 3.04449V4.41949C4.2486 5.14884 4.53833 5.84831 5.05405 6.36404C5.56978 6.87976 6.26925 7.16949 6.9986 7.16949C7.72794 7.16949 8.42741 6.87976 8.94314 6.36404C9.45887 5.84831 9.7486 5.14884 9.7486 4.41949V3.04449C9.7486 2.31515 9.45887 1.61568 8.94314 1.09995C8.42741 0.584226 7.72794 0.294495 6.9986 0.294495Z" fill="#6A6D71"/>
                            </svg>
                        </span>
                        <span class="rtl-login__text">${0}</span>
                    </a>
                </div>
            `), function (e) {
          _this5.showLoginModal();
        }, translations.login);
      } else {
        var href = this.loginUrl + '/' + language + '?url=' + location.href;
        content = html(_t2 || (_t2 = _`
                <div class="rtl-login" @click=${0}>
                    <span class="nav-cat__icon">
                        <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.1236 8.54449H2.8736C2.14425 8.54449 1.44478 8.83423 0.929052 9.34995C0.413327 9.86568 0.123596 10.5651 0.123596 11.2945V15.4195H1.4986V11.2945C1.4986 10.5382 2.1146 9.91949 2.8736 9.91949H11.1236C11.8812 9.91949 12.4986 10.5382 12.4986 11.2945V15.4195H13.8736V11.2945C13.8736 10.5651 13.5839 9.86568 13.0681 9.34995C12.5524 8.83423 11.8529 8.54449 11.1236 8.54449ZM6.9986 1.53199C7.83185 1.53199 8.5111 2.21124 8.5111 3.04449V4.41949C8.49446 4.80948 8.32784 5.17796 8.04601 5.44803C7.76418 5.71809 7.38893 5.86886 6.9986 5.86886C6.60826 5.86886 6.23301 5.71809 5.95118 5.44803C5.66935 5.17796 5.50273 4.80948 5.4861 4.41949V3.04449C5.4861 2.21124 6.16397 1.53199 6.9986 1.53199ZM6.9986 0.294495C6.26925 0.294495 5.56978 0.584226 5.05405 1.09995C4.53833 1.61568 4.2486 2.31515 4.2486 3.04449V4.41949C4.2486 5.14884 4.53833 5.84831 5.05405 6.36404C5.56978 6.87976 6.26925 7.16949 6.9986 7.16949C7.72794 7.16949 8.42741 6.87976 8.94314 6.36404C9.45887 5.84831 9.7486 5.14884 9.7486 4.41949V3.04449C9.7486 2.31515 9.45887 1.61568 8.94314 1.09995C8.42741 0.584226 7.72794 0.294495 6.9986 0.294495Z" fill="#6A6D71"/>
                        </svg>
                    </span>
                    <span class="rtl-login__text">${0}</span>
                </div>

                <div class="rtl-login__submenu" id="login_sub" @click=${0}>
                    <ul class="dropdown-menu">
                        <li class="dropdown-menu__item dropdown-menu__item--header">${0}<br/><div class="dropdown-menu__name">${0}</div></li>
                        <li class="dropdown-menu__item"><a class="dropdown-menu__item--style" href="${0}">${0}</a></li>
                        <li class="dropdown-menu__item dropdown-menu__logout"><a @click=${0}>${0}</a></li>
                    </ul>
                </div>
            `), function (e) {
          _this5.toggleLoginDropdown(e);
        }, translations.myaccount, function (e) {
          e.stopPropagation();
        }, translations.welcome, this.user.firstName + ' ' + this.user.lastName, href, translations.settings, function (e) {
          _this5.logout();
        }, translations.logout);
      }
      if (!this.loaded) content = html(_t3 || (_t3 = _`
            <div class="rtl-login">
                <a href="/login-help" class="rtl-login__action">
                    <span class="nav-cat__icon">
                        <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.1236 8.54449H2.8736C2.14425 8.54449 1.44478 8.83423 0.929052 9.34995C0.413327 9.86568 0.123596 10.5651 0.123596 11.2945V15.4195H1.4986V11.2945C1.4986 10.5382 2.1146 9.91949 2.8736 9.91949H11.1236C11.8812 9.91949 12.4986 10.5382 12.4986 11.2945V15.4195H13.8736V11.2945C13.8736 10.5651 13.5839 9.86568 13.0681 9.34995C12.5524 8.83423 11.8529 8.54449 11.1236 8.54449ZM6.9986 1.53199C7.83185 1.53199 8.5111 2.21124 8.5111 3.04449V4.41949C8.49446 4.80948 8.32784 5.17796 8.04601 5.44803C7.76418 5.71809 7.38893 5.86886 6.9986 5.86886C6.60826 5.86886 6.23301 5.71809 5.95118 5.44803C5.66935 5.17796 5.50273 4.80948 5.4861 4.41949V3.04449C5.4861 2.21124 6.16397 1.53199 6.9986 1.53199ZM6.9986 0.294495C6.26925 0.294495 5.56978 0.584226 5.05405 1.09995C4.53833 1.61568 4.2486 2.31515 4.2486 3.04449V4.41949C4.2486 5.14884 4.53833 5.84831 5.05405 6.36404C5.56978 6.87976 6.26925 7.16949 6.9986 7.16949C7.72794 7.16949 8.42741 6.87976 8.94314 6.36404C9.45887 5.84831 9.7486 5.14884 9.7486 4.41949V3.04449C9.7486 2.31515 9.45887 1.61568 8.94314 1.09995C8.42741 0.584226 7.72794 0.294495 6.9986 0.294495Z" fill="#6A6D71"/>
                        </svg>
                    </span>
                    <span class="rtl-login__text">${0}</span>
                </a>
            </div>
        `), translations.login);
      return html(_t4 || (_t4 = _`
            <style>
            ${0}
            .dropdown-menu__logout::before {
                background: url('${0}') no-repeat;
                content: '';
                background-size: contain;
                width: 22px;
                height: 22px;
                position: absolute;
                top: 9px;
                left: 71px;
            }
            </style>
            ${0}
        `), css, IconLogout, content);
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        loggedIn: {
          type: Boolean
        },
        loaded: {
          type: Boolean
        },
        language: {
          type: String
        }
      };
    }
  }]);
  return NMLogin;
}(LitElement);
export { NMLogin as default };
window.customElements.define('nm-login', NMLogin);